import { Button, Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import ModalCustom from '../utils/ModalCustom/ModalCustom';
import { LockOutlined } from '@ant-design/icons';
import { userApi } from '../../api/user.api';
import useAuthStore from '../../stores/auth.store';

const passwordRules = (t: (key: string) => string) => [
  { required: true },
  { min: 10, message: t('passwordValidation.minLength') },
  { pattern: /[A-Z]/, message: t('passwordValidation.uppercase') },
  { pattern: /[a-z]/, message: t('passwordValidation.lowercase') },
  { pattern: /[0-9]/, message: t('passwordValidation.number') },
  { pattern: /[^A-Za-z0-9]/, message: t('passwordValidation.specialChar') },
];

const ChangePasswordModal = () => {
  const { t } = useTranslation('account');
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const uuid = useAuthStore((state) => state.uuid);

  const handleChangePassword = async () => {
    try {
      const { newPassword } = await form.validateFields();
      await userApi.resetUserPassword(newPassword, uuid!);
      setIsModalOpen(false);
      form.resetFields();
    } catch (error) {
      if (error instanceof Error) {
        messageApi.error(t('common:errors.generic'));
      }
    }
  };

  return (
    <>
      {contextHolder}
      <Button type={'default'} icon={<LockOutlined />} onClick={() => setIsModalOpen(true)}>
        {t('changePassword')}
      </Button>
      <ModalCustom
        title={t('changePassword')}
        description={t('description')}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        footer={
          <Button type={'primary'} onClick={handleChangePassword}>
            {t('save')}
          </Button>
        }
      >
        <Form form={form} layout={'vertical'}>
          <Form.Item label={t('newPass')} name={'newPassword'} rules={passwordRules(t)}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            label={t('repeatNewPass')}
            name={'repeatNewPassword'}
            dependencies={['newPassword']}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('passwordValidation.noMatch')));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </ModalCustom>
    </>
  );
};

export default ChangePasswordModal;
